import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { GRADE_STATUSES as STATUSES } from './constants';

const Grades = ({ grades = [] }) =>
	Boolean(grades.length) && (
		<Stack spacing={0.5}>
			{grades.map(({ label, value, status }) => (
				<Stack spacing={0.75} direction="row" key={`${label}-${value}`}>
					{label && <Typography>{label}</Typography>}
					{value && <Typography color={status}>{value}</Typography>}
				</Stack>
			))}
		</Stack>
	);

Grades.propTypes = {
	grades: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.string,
			status: PropTypes.oneOf(Object.values(STATUSES)),
		}),
	),
};

export default Grades;
